<template>



    <div class="card-buttons">
        <!--JOIN-->


        <template v-if="!isJoined">
            <div class="card-btn__copy">
                Not a member yet?
            </div>
            <div class="card-btn__copy">
                <sk-button secondary block @click.native.stop="onActivate()">Join</sk-button>
            </div>
        </template>

        <!--Card Details-->
        <template v-else-if="isLinked">
            <div class="membership">
                <template>
                    SK Club card number
                    <div class="membership-number">
                        {{CardNumber}}
                    </div>
                </template>

                <template v-if="CardNumber != null">
                    <sk-button primary v-if="!showConfirmReplaceCard" @click.native.stop="showConfirmReplaceCard = true">Replace Card</sk-button>

                    <div v-if="showConfirmReplaceCard">
                        <hr />
                        <h3>Replace Card</h3>
                        <p>{{CardNumber}}</p>
                        <p>By replacing this card number your old card number will no longer work and you will receive an email with a new card number.</p>
                        <p>Are you sure you want to replace your card number now?</p>
                        <sk-layout row>
                            <sk-flex xs12>
                                <sk-button secondary close @click.native.stop="showConfirmReplaceCard = false;">
                                    Wait, take me back.
                                </sk-button>
                            </sk-flex>
                            
                        </sk-layout>
                        <sk-layout row>
                            <sk-flex xs12>
                                <sk-button primary close @click.native.stop="showConfirmReplaceCard = false; replaceCard(CardNumber);">
                                    Yes. I'm sure.
                                </sk-button>
                            </sk-flex>
                        </sk-layout>
                    </div>
                    <div v-if="showReplaceCardError">
                        <p>Your card number could not be replaced at the moment. Please try again later.</p>
                    </div>
                </template>
            </div>
        </template>
        <!--LINK-->
        <!-- <template> -->
            <!-- <sk-form id="link-card-form-sk-club" @submit="onLink(thisCardNumber)"> -->
                <!--Link Copy-->
                <!-- <div class="card-btn__copy" v-if="!showCardAdder  && (!isJoined || !isLinked)">
                    Haven't linked your
                    SK Club Movie Card yet?
                </div> -->
                <!--Link Input-->
                <!-- <div class="card-btn__copy" v-else-if="showCardAdder">
                    <sk-input v-model="thisCardNumber" placeholder="Card Number" required>
                    </sk-input>
                </div> -->
                <!-- Link Buttons-->
                <!--FIXME remove  v-if="!isJoined" to re-enable changing of card number-->
                <!-- <template v-if="!isJoined  || !isLinked">
                    <div class="card-btn__copy" v-if="!showCardAdder">
                        <sk-button :disabled="disabled" :primary="!isJoined || !isLinked" :secondary="isJoined && isLinked" block
                                   @click.native.stop="showCardAdder = true">
                            {{isJoined && isLinked ? 'Change Card' : 'Link it now'}}
                        </sk-button>
                    </div>
                    <template v-else>
                        <div class="card-btn__copy">
                            <sk-button primary block type="submit" :loading="linking && !joining">
                                {{isJoined ? 'Change' : 'Link'}}
                            </sk-button>
                        </div>
                        <div class="card-btn__copy">
                            <sk-button secondary block @click.native.stop="showCardAdder = false"
                                       :disabled="linking">
                                Cancel
                            </sk-button>
                        </div>


                    </template>
                </template> -->
            <!-- </sk-form> -->
        <!-- </template> -->
    </div>

</template>

<script type="application/javascript">
    import cardMixin from './cardMixin'
    import {AuthService} from 'hasta-la-vista-middleware-api/service'
    export default{
        name: 'cardSkClub',

        data() {
            return {
                showReplaceCardError: false,
                showConfirmReplaceCard: false,
            }
        },
        methods: {
            replaceCard(CardNumber) {
                this.showReplaceCardError = false
                // console.log("replace card functionality")
                Promise.all([AuthService.replaceCard(CardNumber)]).then((replaceCard) => {
                    // console.log("replaceCard", replaceCard);
                    // console.log("replaceCard[0]", replaceCard[0].replacedCard);
                    // console.log("replaceCard", replaceCard.replacedCard);
                    if(replaceCard != undefined && replaceCard != null) {
                        if(replaceCard[0].replacedCard) {
                            let replacedCard = true
                            window.localStorage.setItem('skClubReplaceCard', JSON.stringify(replacedCard));
                            location.reload();
                        } else {
                            this.showReplaceCardError = true
                        }
                    } else {
                        this.showReplaceCardError = true
                    }
                })
                this.showConfirmReplaceCard = false
            },
        },
        created(){
            this.showConfirmReplaceCard = false
        },
        mixins: [cardMixin],


    }
</script>


// WEBPACK FOOTER //
// card-sk-club.vue?33261bd8